import React, { ChangeEvent } from 'react';

interface InputFieldProps {
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => any;
  value: any;
}

const InputField = ({ placeholder, onChange, value }: InputFieldProps) => {
  return (
    <div className='w-[90%] mb-12'>
      <input
        type="text"
        className="border-b-2 border-black focus:outline-none placeholder:text-left placeholder:text-gray-500 w-[98%] text-xl"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}

export default InputField;
